type SVGIconProps = {
  width: number;
  height: number;
};

type IconWithToastProps = {
  size?: number;
  SVGIcon: React.ElementType<SVGIconProps>;
  content: React.ReactNode;
};

export default function IconWithToast({
  size = 20,
  SVGIcon,
  content,
}: IconWithToastProps) {
  return (
    <div className="gap-[4px] flex">
      <SVGIcon height={size} width={size} />
      <p className="font_label_regular_lg content_primary_inverse">{content}</p>
    </div>
  );
}
